import { makeCall } from "./graph";
import {
  updateProviderDrMode as update,
  getProviderDrMode as get,
  ProviderDrMode,
} from "lib/graphql";

export const updateProviderDrMode = async (
  mode: ProviderDrMode
): Promise<ProviderDrMode[] | undefined> => {
  return await makeCall<ProviderDrMode[]>("updateProviderDrMode", update, mode);
};

export const getProviderDrMode = async (): Promise<
  ProviderDrMode[] | undefined
> => {
  return await makeCall<ProviderDrMode[]>("getProviderDrMode", get);
};
